import { FC } from 'react'
import { DeliveryClothes } from '../components/DeliveryClothes'

const HeaderDeliveryClothesPanel: FC = () => {
  return (
    <>
      <DeliveryClothes />
    </>
  )
}

export { HeaderDeliveryClothesPanel }
